import { FunctionComponent } from 'react';
import cn from 'classnames';
import styles from './OverviewCard.module.css';

const OverviewCardSkeleton: FunctionComponent<{ className?: string }> = ({ className }) => {
  return (
    <div className={cn(styles.skeletonCard, className)}>
      <div className={styles.cardDataHeader}>
        <div className={styles.cardData}>
          <div className={styles.skeletonTitle}></div>
          <div className={styles.skeletonValue}></div>
        </div>
        <div className={styles.cardDataIcon}>
          <div className={styles.skeletonIcon}></div>
        </div>
      </div>
      <div className={styles.cardDataFooter}>
        <div className={styles.skeletonFooter}></div>
      </div>
    </div>
  );
};

export default OverviewCardSkeleton;
